module.exports = __webpack_public_path__ + "img/pic7.45fcff49.png";